export const menu = ([
   {
      name : 'Inicio',
      path : '/',
      icon : 'fa fa-dashboard',
      submenus: []
   },
   {
      name : 'Documentos',
      path : '/estructura_documentos',
      icon : 'fa fa-file',
      submenus : [
         {
            sub_name : 'Categoria Documentos',
            sub_path : '/categoria_documentos'
         },
         {
            sub_name : 'Conceptos Generales',
            sub_path : '/conceptos_generales'
         },
         {
            sub_name : 'Conceptos',
            sub_path : '/conceptos'
         },
         {
            sub_name : 'Conceptos Descuento',
            sub_path : '/conceptos_descuento'
         },
         {
            sub_name : 'Categorias',
            sub_path : '/categorias'
         },
         {
            sub_name : 'Tipos de documentos',
            sub_path : '/tipo_documentos'
         }
      ]
   },
   {
      name : 'Clientes',
      path : '/clientes',
      icon : 'fa fa-users',
      submenus: []
   },
   {
      name : 'Configuración',
      path : '/configuracion',
      icon : 'fa fa-cog',
      submenus : [
         {
            sub_name : 'Empresa',
            sub_path : '/empresa'
         },
         {
            sub_name : 'Cuenta Honorarios',
            sub_path : '/banco_honorarios'
         },
         {
            sub_name : 'Cuenta Impuestos',
            sub_path : '/banco_impuestos'
         },
         {
            sub_name : 'Usuarios',
            sub_path : '/usuarios'
         }
      ]
   },
   {
      name : 'Isabi',
      path : '/isabi_impuestos',
      icon : 'fa fa-circle-o',
      submenus : [
         {
            sub_name : 'Isabi Impuestos',
            sub_path : '/isabi_impuestos'
         },
         {
            sub_name : 'Pagos Confirmados',
            sub_path : '/isabis_confirmados'
         }
      ]
   },
   {
      name : 'Pagos Presupuesto',
      path : '/pagos_presupuesto',
      icon : 'fa fa-dollar',
      submenus : []
   }
]);